import request from 'utils/request';

const PREFIX = '/api/detail/billing/';

export const api = {
  DETAIL_BILLING_LIST: PREFIX + 'list',
  DETAIL_BILLING_ADD: PREFIX + 'add',
  DETAIL_BILLING: PREFIX,
  DETAIL_BILLING_INFO: PREFIX + 'info/',
  DETAIL_BILLING_UPLOAD: PREFIX + 'upload',
  DETAIL_BILLING_UPDATE: PREFIX + 'update',
  DETAIL_BILLING_DOWNLOAD: PREFIX + 'download',
  DETAIL_BILLING_DOWNLOAD_TEMPLATE: PREFIX + 'download/template',
};

export function detailBillingDownload(data) {
  return request({
    url: api.DETAIL_BILLING_DOWNLOAD,
    method: 'post',
    responseType: 'blob',
    data,
  });
}
export function detailBillingDownloadTemplate() {
  return request({
    url: api.DETAIL_BILLING_DOWNLOAD_TEMPLATE,
    method: 'get',
    responseType: 'blob',
  });
}

export function detailBillingList(data) {
  return request({
    url: api.DETAIL_BILLING_LIST,
    method: 'post',
    data,
  });
}

export function detailBillingAdd(data) {
  return request({
    url: api.DETAIL_BILLING_ADD,
    method: 'post',
    data,
  });
}

export function detailBillingDelete(id) {
  return request({
    url: api.DETAIL_BILLING + id,
    method: 'delete',
  });
}

export function detailBillingInfo(id) {
  return request({
    url: api.DETAIL_BILLING_INFO + id,
    method: 'get',
  });
}

export function detailBillingUpdate(data) {
  return request({
    url: api.DETAIL_BILLING_UPDATE,
    method: 'put',
    data,
  });
}
